/** @jsx jsx */
import { Modal, Spacer, TextGroupMedium } from "@cd2/components/build/es6"
import { IComponentProp, IComponentProps } from "@cd2/tools"
import { css, jsx } from "@emotion/core"
import React, { useEffect } from "react"
import { ConfirmCancelButtons } from "./Buttons/ConfirmCancelButtons"

interface IProps extends IComponentProps<typeof ConfirmCancelButtons> {
  heading: IComponentProp<typeof TextGroupMedium, "heading">
  body?: IComponentProp<typeof TextGroupMedium, "body">
  isOpen?: boolean
  children?: React.ReactNode
  disabled?: boolean
  width?: number
  noOverflow?: boolean
  onOpenAutoFocus?(): void
}

export function ConfirmCancelDialogue({
  onConfirm,
  onCancel,
  heading,
  body,
  isOpen,
  children,
  buttonOpts,
  disabled,
  width = 450,
  noOverflow,
  onOpenAutoFocus,
  ...props
}: IProps) {
  useEffect(() => {
    if (isOpen && onOpenAutoFocus) {
      onOpenAutoFocus()
    }
  }, [isOpen, onOpenAutoFocus])
  return (
    <Modal
      isOpen={!!isOpen}
      onRequestClose={onCancel}
      width={width}
      css={css`
        max-width: calc(100% - 16px);
        overflow: ${noOverflow ? "visible !important" : "initial"};
        text-align: left;
      `}
      render={() => (
        <div
          css={css`
            overflow: ${noOverflow ? "visible !important" : "auto"};
          `}
        >
          <TextGroupMedium
            heading={heading}
            body={body}
            theme={{ heading: { size: "small", blockSpacing: 0.5 } }}
          />
          <Spacer size={24} />
          {children && (
            <React.Fragment>
              {children}
              <Spacer />
            </React.Fragment>
          )}
          <ConfirmCancelButtons
            onConfirm={onConfirm}
            onCancel={onCancel}
            buttonOpts={buttonOpts}
            disabled={disabled}
            extraButtons={props.extraButtons}
          />
          <Spacer size={4} />
        </div>
      )}
    />
  )
}
